import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { getBuildAndPriceLink } from 'site-modules/shared/utils/build-and-price-link-constructor';
import { generateNewFlatUrl } from 'site-modules/shared/utils/srp-link-constructor';
import { TrimPricingBars } from 'site-modules/shared/components/core-page/trim-pricing-bars/trim-pricing-bars';
import { PricingCta } from './pricing-cta/pricing-cta';

import './pricing-module.scss';

export function PricingModule({
  params,
  vehicle,
  trimsFeatures = null,
  isInternational = false,
  isSeot5678Enabled = false,
  isAds12859Enabled = false,
  isClientSiteServedAds = false,
}) {
  return (
    <div className="pricing-module">
      <TrimPricingBars
        className="mb-1_5"
        params={params}
        vehicle={vehicle}
        trimsFeatures={trimsFeatures}
        isInternational={isInternational}
        isSeot5678Enabled={isSeot5678Enabled}
        isAds12859Enabled={isAds12859Enabled}
        isClientSiteServedAds={isClientSiteServedAds}
      />
      <div className="text-center">
        <PricingCta
          vehicle={vehicle}
          buildAndPriceLink={getBuildAndPriceLink({
            make: params.make,
            model: params.model,
          })}
          srpLink={generateNewFlatUrl(params)}
        />
      </div>
    </div>
  );
}

PricingModule.propTypes = {
  params: CorePageParams.isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  trimsFeatures: PropTypes.objectOf(PropTypes.string),
  isInternational: PropTypes.bool,
  isSeot5678Enabled: PropTypes.bool,
  isAds12859Enabled: PropTypes.bool,
  isClientSiteServedAds: PropTypes.bool,
};
